import * as React from 'react'
import { MultiSelect } from '@mantine/core'

type TripProps = {
	id: string
	name: string
	firstUploadId: string
}

interface Props {
	trips: TripProps[]
	onChange: (tripIds: number[]) => void
	placeholder?: string
	initialValue?: number[]
}

const TripFilterInput = ({
	trips,
	onChange,
	placeholder,
	initialValue,
}: Props) => {
	const [value, setValue] = React.useState<string[]>(
		(initialValue ?? []).map((i) => i.toString()),
	)

	const tripsData = React.useMemo(
		() =>
			trips.map((trip) => ({
				value: trip.id,
				label: trip.name,
			})),
		[trips],
	)

	React.useEffect(() => {
		const newValue = value.map((v) => +v)
		if (JSON.stringify(initialValue) !== JSON.stringify(newValue)) {
			if (!value) {
				onChange([])
			} else {
				onChange(newValue)
			}
		}
	}, [value])

	React.useEffect(() => {
		const strInitialValue = (initialValue ?? []).map((v) => v.toString())

		if (JSON.stringify(initialValue) !== JSON.stringify(value)) {
			setValue(strInitialValue)
		}
	}, [initialValue])

	return (
		<div id="trip-filter-input" style={{ position: 'relative', zIndex: 100 }}>
			<MultiSelect
				data={tripsData}
				searchable={true}
				value={value}
				placeholder={placeholder ?? 'Select trips...'}
				disabled={tripsData.length < 2}
				onChange={setValue}
				clearable={value.length > 1}
				size="md"
				// styles={(theme) => ({
				// 	dropdown: {
				// 		position: 'absolute',
				// 		top: '100%',
				// 		left: 0,
				// 		right: 0,
				// 		zIndex: 1001,
				// 		boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
				// 	},
				// })}
			/>
		</div>
	)
}

export default TripFilterInput
